import { html } from 'lit';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import { editorNodeClass, editorNodeClick, editorNodePointerDown, editorNodeStyle, type LandingEditorRenderOptions } from '../editor/landingEditorRender.js';
import { companyMatchingDemo } from './companyMatchingDemo.js';
import './companyPlatformHeroElement.js';

export const companyMatchingSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <vp-company-platform-hero data-motion=${editor?.mode === 'editor' ? 'off' : content.companyObjections.motion}
    class=${editorNodeClass(editor, 'section.companyMatching', 'vp-company-platform vp-company-matching')} style=${editorNodeStyle(editor, 'section.companyMatching')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.companyMatching', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.companyMatching', event)}>
    <div class="vp-company-platform-sticky">
      <div class="vp-company-platform-aura" aria-hidden="true"></div>
      <div class="vp-company-platform-copy">
        ${editorSemanticText({ editor, elementId: 'companyPlatformHero.demoTitle', fallbackTag: 'h2', className: 'vp-company-section-title', content: content.companyPlatformHero.demoTitle })}
        ${editorSemanticText({ editor, elementId: 'companyPlatformHero.demoIntro', fallbackTag: 'p', className: 'vp-company-matching-intro', content: content.companyPlatformHero.demoIntro })}
        <span class="vp-company-platform-preview-slot" aria-hidden="true"></span>
      </div>
      ${companyMatchingDemo({ hero: content.companyPlatformHero, editor })}
    </div>
  </vp-company-platform-hero>
`;
